import { memo } from 'react'

import { MapWrapperGuard } from './MapWrapperGuard'

const MapWrapperGuardMemo = memo(MapWrapperGuard)

export default MapWrapperGuardMemo
